// @flow
import './index.less';

import { CheckCircleFilled } from '@ant-design/icons';

import React, { useMemo } from 'react';

type Props = {
  step: number,
  title: string,
  status?: 'default' | 'active' | 'completed',
  asideNode?: React$Node,
};

const StepTitle = ({ step, title, status = 'default', asideNode }: Props): React$Node => {
  const iconElem = useMemo(() => {
    switch (status) {
      case 'active':
        return <span className="step-icon step-icon-active">{step}</span>;

      case 'completed':
        return <CheckCircleFilled style={{ color: '#b00015', fontSize: 24.8 }} />;

      case 'default':
      default:
        return <span className="step-icon">{step}</span>;
    }
  }, [step, status]);

  return (
    <div className={`step-title step-title-${status}`}>
      <div className="step-title-container">
        {iconElem}
        <span className="title">{title}</span>
      </div>
      {asideNode}
    </div>
  );
};

export default StepTitle;
